import React, { useEffect } from 'react';
import { Container, Row, Col, Image, Badge, Table } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/Pictron11Style.css";
import pictronHeroImage from '../Assets/pback.png';
import pictronBeforeAfter from '../Assets/pbefore.png';
import pictronTattooRemoval from '../Assets/ptato.png';
import pictronChart from '../Assets/pchart.png';
import pictronHandpieces from '../Assets/phandle.png';
import pictronTreatment from '../Assets/pback.png';

const Pictron11Page = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: false
    });
  }, []);

  const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/pictron11.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'pictron-11.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/pictron11.pdf", '_blank');
    });
};

  
  // Key features
  const features = [
    {
      id: 1,
      title: "Highest Power",
      description: "Most powerful multi-wavelength picosecond laser available",
      icon: "fas fa-bolt",
      color: "#9C27B0"
    },
    {
      id: 2,
      title: "550ps Pulses",
      description: "Shortest pulse duration reduces pain & erythema",
      icon: "fas fa-stopwatch",
      color: "#3F51B5"
    },
    {
      id: 3,
      title: "4 Wavelengths",
      description: "532nm, 585nm, 650nm, 1064nm for complete coverage",
      icon: "fas fa-palette",
      color: "#00BCD4"
    },
    {
      id: 4,
      title: "Dual Pulse Mode",
      description: "Enhanced photoacoustic effect for better results",
      icon: "fas fa-wave-square",
      color: "#FF9800"
    }
  ];

  // Handpieces
  const handpieces = [
    {
      name: "Focus Handle",
      type: "Standard",
      uses: ["Melasma", "Freckles", "Sunspots", "Black Tattoos", "Skin Rejuvenation"],
      icon: "fas fa-crosshairs"
    },
    {
      name: "Honeycomb Handle",
      type: "Optional",
      uses: ["Skin Rejuvenation", "Dermal Spots", "Ota's Nevus", "Birthmarks"],
      icon: "fas fa-honeycomb"
    },
    {
      name: "Gaussian Handle",
      type: "Optional",
      uses: ["Freckles", "Sunspots", "Black Tattoos", "Eyeliner Removal"],
      icon: "fas fa-chart-line"
    },
    {
      name: "650nm Handle",
      type: "Optional",
      uses: ["Green Tattoos"],
      icon: "fas fa-square",
      color: "#00FF00"
    },
    {
      name: "585nm Handle",
      type: "Optional",
      uses: ["Red/Purple Tattoos", "Multicolor Tattoos"],
      icon: "fas fa-square",
      color: "#FF0000"
    },
    {
      name: "Fractional Handle",
      type: "Optional",
      uses: ["Wrinkles", "Scars", "Acne Scars", "Pores"],
      icon: "fas fa-th"
    }
  ];

  // Treatment indications
  const indications = [
    { name: "Skin Rejuvenation", icon: "fas fa-sparkles" },
    { name: "Tattoo Removal", icon: "fas fa-paint-brush" },
    { name: "Lentigines", icon: "fas fa-circle" },
    { name: "Acne Scars", icon: "fas fa-certificate" },
    { name: "Wrinkles Reduction", icon: "fas fa-wave-square" },
    { name: "Pores & Texture", icon: "fas fa-dot-circle" },
    { name: "Birthmarks", icon: "fas fa-leaf" },
    { name: "Pigmented Lesions", icon: "fas fa-cloud" }
  ];

  // Treatment progress examples
  const treatmentExamples = [
    {
      wavelength: "532nm",
      spotSize: "2mm",
      frequency: "1Hz",
      power: "152mJ"
    },
    {
      wavelength: "1064nm",
      spotSize: "1mm",
      frequency: "1Hz",
      power: "600mJ"
    },
    {
      wavelength: "1064nm",
      spotSize: "2mm",
      frequency: "3Hz",
      power: "500mJ"
    },
    {
      wavelength: "532nm",
      spotSize: "2mm",
      frequency: "1Hz",
      power: "175mJ"
    }
  ];

  // Benefits
  const benefits = [
    "Shortest Pulse Duration for High Peak Power",
    "Unique Double Pulse Mode",
    "Suitable for All Skin Types",
    "Improved ROI with Fewer Treatments",
    "Versatile Platform with Multiple Options",
    "9 Different Spot Sizes (2mm to 10mm)"
  ];

  return (
    <div className="pictron11-product-page">
      {/* Hero Section */}
      <section className="pictron11-hero-section">
        <Container>
          <Row className="align-items-center min-vh-80">
            <Col md={5} className="hero-content" data-aos="fade-right">
              <Badge bg="light" text="dark" className="mb-3" data-aos="fade-up">
                <i className="fas fa-gem me-2"></i>
                Next-Generation Picosecond Laser
              </Badge>
              <h1 className="product-title animate-charcter-pictron">
                PICTRON11
              </h1>
              <h2 className="product-subtitle">
                PICOSECOND LASER SYSTEM
              </h2>
              <p className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                Highest Power of Any Multi-Wavelength Picosecond Laser
              </p>
              
              <div className="pulse-badge" data-aos="fade-up" data-aos-delay="300">
                <div className="pulse-value">550ps</div>
                <div className="pulse-label">PULSE DURATION</div>
              </div>
              
              <div className="tech-badges" data-aos="fade-up" data-aos-delay="400">
                {features.map(feature => (
                  <span key={feature.id} className="tech-badge" style={{ borderColor: feature.color }}>
                    <i className={feature.icon} style={{ color: feature.color }}></i>
                    {feature.title}
                  </span>
                ))}
              </div>
            </Col>
            
            <Col md={7} className="text-center" data-aos="fade-left" data-aos-delay="200">
              <div className="device-container">
             <br></br>
                <Image 
                  src={pictronHeroImage} 
                  fluid 
                  className="product-hero-image pictron-floating" 
                  alt="PICTRON11 Picosecond Laser"
                />
                <div className="laser-beams">
                  <div className="beam beam-1" style={{ background: 'linear-gradient(90deg, #9C27B0, transparent)' }}></div>
                  <div className="beam beam-2" style={{ background: 'linear-gradient(90deg, #3F51B5, transparent)' }}></div>
                  <div className="beam beam-3" style={{ background: 'linear-gradient(90deg, #00BCD4, transparent)' }}></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Key Features */}
      <section className="features-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={10} className="text-center" data-aos="fade-up">
              <div className="pictron-icon mb-4" data-aos="zoom-in">
                <i className="fas fa-satellite-dish"></i>
              </div>
              <h2 className="section-title pictron-title mb-4">
                Ultra-Short Pulse <span className="text-highlight">Performance</span>
              </h2>
              <p className="intro-text pictron-description">
                PICTRON11 delivers cutting-edge precision with an exceptionally brief pulse duration 
                of just 550-750 picoseconds—among the fastest in its class. This advanced, versatile 
                system empowers practitioners to customize treatments by adjusting key parameters 
                for truly personalized results.
              </p>
            </Col>
          </Row>
          
          {/* Feature Cards */}
          <Row className="g-4 mt-5">
            {features.map((feature, index) => (
              <Col lg={3} md={6} key={feature.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="feature-card" style={{ borderTopColor: feature.color }}>
                  <div className="feature-card-icon" style={{ color: feature.color }}>
                    <i className={feature.icon}></i>
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                  <div className="feature-glow" style={{ background: feature.color }}></div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Technology Explanation */}
      <section className="tech-section py-5 bg-dark text-white">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="process-visualization">
                <Image 
                  src={pictronChart} 
                  fluid 
                  className="process-image shadow-lg" 
                  alt="PICTRON11 Technology Process"
                />
                <div className="process-step" style={{ top: '20%', left: '20%' }} data-aos="fade-down">
                  <div className="step-marker" style={{ background: '#9C27B0' }}></div>
                  <span>Laser Beam Penetration</span>
                </div>
                <div className="process-step" style={{ top: '50%', left: '50%' }} data-aos="fade-down" data-aos-delay="100">
                  <div className="step-marker" style={{ background: '#3F51B5' }}></div>
                  <span>Photoacoustic Effect</span>
                </div>
                <div className="process-step" style={{ top: '80%', right: '20%' }} data-aos="fade-down" data-aos-delay="200">
                  <div className="step-marker" style={{ background: '#00BCD4' }}></div>
                  <span>Immune System Clearance</span>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <h2 className="section-title pictron-title mb-4">
                Dual-Sequence <span className="text-highlight">Emission Technology</span>
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4">
                PICTRON11 incorporates an innovative dual-pulse delivery system that emits two 
                precisely timed pulses in each laser cycle. This unique approach amplifies traditional 
                picosecond laser advantages by intensifying the photoacoustic effect while introducing 
                a controlled thermal component.
              </p>
              
              <div className="tech-explanation">
                <h5 className="mb-3">How It Works:</h5>
                <div className="explanation-steps">
                  <div className="step" data-aos="fade-up">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h6>Ultra-Short Pulses</h6>
                      <p>550-750ps pulses create strong energy bursts that break pigments into tiny pieces</p>
                    </div>
                  </div>
                  <div className="step" data-aos="fade-up" data-aos-delay="100">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h6>Dual-Pulse Enhancement</h6>
                      <p>Special double-pulse mode breaks ink better with more power and stronger shock effects</p>
                    </div>
                  </div>
                  <div className="step" data-aos="fade-up" data-aos-delay="200">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h6>Natural Clearance</h6>
                      <p>Immune system identifies and disposes of fragmented particles</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Handpieces Section */}
      <section className="handpieces-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title pictron-title" data-aos="fade-up">
                Wide Variety of <span className="text-highlight">Applicators</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                Comprehensive range of specialized handpieces for targeted treatments
              </p>
            </Col>
          </Row>
          
          <Row className="g-4 mb-5">
            <Col lg={6} data-aos="fade-right">
              <div className="handpieces-display">
                <Image 
                  src={pictronHandpieces} 
                  fluid 
                  className="handpieces-image floating-rotate" 
                  alt="PICTRON11 Handpieces"
                />
                <div className="handpieces-glow"></div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="handpieces-info">
                <h3 className="mb-4">Specialized Handpieces</h3>
                
                <Row className="g-3">
                  {handpieces.slice(0, 3).map((handpiece, index) => (
                    <Col md={12} key={index}>
                      <div className="handpiece-card">
                        <div className="handpiece-header">
                          <i className={handpiece.icon} style={handpiece.color ? { color: handpiece.color } : {}}></i>
                          <div>
                            <h5>{handpiece.name}</h5>
                            <Badge bg={handpiece.type === 'Standard' ? 'primary' : 'secondary'} className="ms-2">
                              {handpiece.type}
                            </Badge>
                          </div>
                        </div>
                        <div className="handpiece-uses mt-2">
                          {handpiece.uses.map((use, i) => (
                            <span key={i} className="use-tag">{use}</span>
                          ))}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
          
          {/* More Handpieces */}
          <Row className="g-3">
            {handpieces.slice(3).map((handpiece, index) => (
              <Col lg={4} md={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="handpiece-card">
                  <div className="handpiece-header">
                    <i className={handpiece.icon} style={handpiece.color ? { color: handpiece.color } : {}}></i>
                    <div>
                      <h5>{handpiece.name}</h5>
                      <Badge bg="secondary" className="ms-2">Optional</Badge>
                    </div>
                  </div>
                  <div className="handpiece-uses mt-2">
                    {handpiece.uses.map((use, i) => (
                      <span key={i} className="use-tag">{use}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Indications Section */}
      <section className="indications-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title pictron-title" data-aos="fade-up">
                Full Range of <span className="text-highlight">Indications</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {indications.map((indication, index) => (
              <Col lg={3} md={4} sm={6} key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="indication-card">
                  <div className="indication-icon">
                    <i className={indication.icon}></i>
                  </div>
                  <h5>{indication.name}</h5>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Before & After Results */}
      <section className="results-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="results-comparison">
                <Image 
                  src={pictronBeforeAfter} 
                  fluid 
                  className="results-image shadow-lg" 
                  alt="PICTRON11 Before & After Results"
                />
                <div className="comparison-label before" data-aos="fade-right">
                  <span>Before</span>
                </div>
                <div className="comparison-label after" data-aos="fade-left" data-aos-delay="200">
                  <span>After</span>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="tattoo-removal-demo">
                <Image 
                  src={pictronTattooRemoval} 
                  fluid 
                  className="tattoo-image shadow-lg" 
                  alt="Tattoo Removal Process"
                />
                <div className="demo-info">
                  <h4 className="mb-3">Tattoo Removal Excellence</h4>
                  <p>
                    PICTRON11 effectively removes both multicolored and black tattoos with 
                    specialized handpieces at four different wavelengths combined with 
                    ps-domain pulsewidth.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          
          {/* Treatment Examples */}
          <Row className="mt-5">
            <Col lg={12}>
              <div className="treatment-examples" data-aos="fade-up">
                <h4 className="text-center mb-4">Treatment Progress Examples</h4>
                <Row className="g-3">
                  {treatmentExamples.map((example, index) => (
                    <Col lg={3} md={6} key={index}>
                      <div className="treatment-card">
                        <div className="treatment-header">
                          <i className="fas fa-wave-square"></i>
                          <h5>Wavelength: {example.wavelength}</h5>
                        </div>
                        <div className="treatment-details">
                          <div className="detail">
                            <span className="label">Spot Size:</span>
                            <span className="value">{example.spotSize}</span>
                          </div>
                          <div className="detail">
                            <span className="label">Frequency:</span>
                            <span className="value">{example.frequency}</span>
                          </div>
                          <div className="detail">
                            <span className="label">Power:</span>
                            <span className="value">{example.power}</span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Benefits & Specifications */}
      <section className="specs-section py-5 bg-dark text-white">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title pictron-title" data-aos="fade-up">
                System <span className="text-highlight">Specifications</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            <Col lg={6} data-aos="fade-right">
              <div className="specs-card">
                <h4 className="mb-4">Key Benefits</h4>
                <ul className="benefits-list">
                  {benefits.map((benefit, index) => (
                    <li key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                      <i className="fas fa-check-circle me-2"></i>
                      {benefit}
                    </li>
                  ))}
                </ul>
                
                <div className="portability-info mt-4" data-aos="fade-up">
                  <h5 className="mb-3">Operationally Flexible & Portable</h5>
                  <div className="portability-features">
                    <div className="feature">
                      <i className="fas fa-bolt"></i>
                      <span>Quick readiness in 60 seconds</span>
                    </div>
                    <div className="feature">
                      <i className="fas fa-power-off"></i>
                      <span>Efficient power use between sessions</span>
                    </div>
                    <div className="feature">
                      <i className="fas fa-plug"></i>
                      <span>Standard 220-volt operation</span>
                    </div>
                    <div className="feature">
                      <i className="fas fa-arrows-alt-h"></i>
                      <span>7-articulated light guide transmission</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="specs-table">
                <h4 className="mb-4">Technical Specifications</h4>
                <Table responsive className="specs-table-content">
                  <tbody>
                    <tr>
                      <td><strong>Wavelengths:</strong></td>
                      <td>1064nm, 650nm, 585nm, 532nm</td>
                    </tr>
                    <tr>
                      <td><strong>Spot Size:</strong></td>
                      <td>2-10mm (9 different sizes)</td>
                    </tr>
                    <tr>
                      <td><strong>Pulse Energy:</strong></td>
                      <td>50-2000mL per pulse</td>
                    </tr>
                    <tr>
                      <td><strong>Pulse Duration:</strong></td>
                      <td>550-750ps</td>
                    </tr>
                    <tr>
                      <td><strong>Pulse Shape:</strong></td>
                      <td>Single, Double, Continuous pulse</td>
                    </tr>
                    <tr>
                      <td><strong>Frequency:</strong></td>
                      <td>Up to 10 Hz</td>
                    </tr>
                    <tr>
                      <td><strong>Cooling:</strong></td>
                      <td>Closed water circulation</td>
                    </tr>
                    <tr>
                      <td><strong>Interface:</strong></td>
                      <td>15.6" TFT True Color LCD Screen</td>
                    </tr>
                  </tbody>
                </Table>
                
                <div className="treatment-display mt-4" data-aos="fade-up">
                  <Image 
                    src={pictronTreatment} 
                    fluid 
                    className="treatment-image rounded-lg" 
                    alt="PICTRON11 Treatment Interface"
                  />
                  <div className="display-overlay">
                    <div className="display-info">
                      <h5>Advanced Interface</h5>
                      <p>15.6" TFT True Color LCD Screen for precise control</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Warning Section */}
      <section className="warning-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <div className="warning-card" data-aos="fade-up">
                <div className="warning-icon">
                  <i className="fas fa-exclamation-triangle"></i>
                </div>
                <div className="warning-content">
                  <h4>Important Safety Information</h4>
                  <p className="mb-3">
                    The EPILYUM PICTON11 picosecond laser is intended exclusively for use by 
                    physicians trained in picosecond laser technology. Improper treatment 
                    settings or misuse can result in serious injury.
                  </p>
                  <p className="mb-0">
                    <strong>Risks may include:</strong> Transient erythema, edema, hypo- or 
                    hyperpigmentation, infection, skin induration, blistering, or scarring. 
                    Always review the user manual for full intended uses, contraindications, 
                    and precautions.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Download Section */}
      <section className="download-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title pictron-title mb-4">
                Download <span className="text-highlight">Complete Documentation</span>
              </h2>
              <p className="lead mb-5">
                Technical specifications, treatment protocols, and clinical guides
              </p>
              
              <div className="laser-preview mb-5" data-aos="zoom-in">
                <div className="laser-3d">
                  <div className="laser-front">
                    <h3>PICTRON<sup>11</sup></h3>
                    <p>Picosecond Laser System</p>
                    <div className="wavelength-tags">
                      <span style={{ background: '#9C27B0' }}>1064nm</span>
                      <span style={{ background: '#3F51B5' }}>650nm</span>
                      <span style={{ background: '#FF0000' }}>585nm</span>
                      <span style={{ background: '#00BCD4' }}>532nm</span>
                    </div>
                  </div>
                  <div className="laser-side"></div>
                </div>
              </div>
              
              <button 
                onClick={handleOpenPDF}
                className="btn btn-primary btn-lg download-btn pulse"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <i className="fas fa-download me-2"></i> Download PICTRON11 Brochure (PDF)
              </button>
              
              <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
                <small>Includes all technical features, safety guidelines, and treatment protocols</small>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Pictron11Page;